export default {
  name: "development",
  api: {
    endpoints: {
      usersList: "/2.0/user/list",
      createUser: "/2.0/user",
      updateUser: "/1.0/user",
      searchUsers: "/2.0/user/search",
      userPermissions: "/2.0/user/permissions",
      user:"/2.0/user",
      resetPassword: "/2.0/user/reset",
      blockUser: "/2.0/user/block",
      unblockUser: "/2.0/user/unblock",
      userDetail: "/2.0/user",
      userTemplates: "/2.0/user/templates",
      currentUser: "/2.0/user/detail",
      checkUsernameAvailability: "/2.0/user/check",
      workloadWorkkards: "/2.0/user/workload/workkards",
      workloadActivities: "/2.0/user/workload/activities",
      workloadTransfer: "/2.0/user/workload/transfer"
    },
    mockEndpoints: {
      usersList: "/api/users/userslist",
      userDetail: "/api/users/userdetail",
      checkUsernameAvailability: "/api/users/checkusername",
      createUser: "/api/users/createuser",
      updateUser: "/api/users/updateuser",
      resetPassword: "/api/users/resetpassword",
      blockUser: "/api/users/blockuser",
      unblockUser: "/api/users/unblockuser",
      searchUsers: "/api/users/searchusers",
      userTemplates: "/api/users/usertemplates",
      currentUser: "/api/users/currentuser",
      userDetail: "/api/users/userdetails",
      workloadWorkkards: "/api/users/workload/workkards",
      workloadActivities: "/api/users/workload/activities",
      workloadTransfer: "/api/users/workload/transfer",
    },
  },
  params: { 
    usersList: {
      page: "page_no",
      limit: "page_size",
      search: "query",
      sortBy: "sortField",
      sortOrder: "sortDirection",
    },
  },
};